import { MCAttachmentInfo, MCCommunicationDetails, MCUser } from "@maslul/common-services";

export class ApplicantDetails extends MCUser {
    isPackageYours: string | undefined;
    packageOwnerId: string | undefined;
    packageOwnerFirstName: string | undefined;
    packageOwnerLastName: string | undefined;
    packageOwnerCommunicationDetails: MCCommunicationDetails | undefined;
    powerOfAttorney: MCAttachmentInfo = new MCAttachmentInfo();


    constructor(applicantDetails?: ApplicantDetails) {

        super(applicantDetails as MCUser)
        if (applicantDetails) {
            this.isPackageYours = applicantDetails.isPackageYours;
            this.packageOwnerId = applicantDetails.packageOwnerId;
            this.packageOwnerFirstName = applicantDetails.packageOwnerFirstName;
            this.packageOwnerLastName = applicantDetails.packageOwnerLastName;
            this.packageOwnerCommunicationDetails = new MCCommunicationDetails(applicantDetails.packageOwnerCommunicationDetails);
            this.powerOfAttorney = new MCAttachmentInfo(applicantDetails.powerOfAttorney);
        }

    }
}
